<mat-card>
	<mat-card-header>
		<mat-card-title>
			{{ displayString }}
		</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
	</mat-card-content>
</mat-card>
